/* ts-sliping-gruppe.js – Tomatosharp (12/10 2026)
   «Knivsliping per post» som én gruppert bestilling i kurvskuff og på /cart. Markup: snippets/ts-sliping-gruppe.liquid.
   Linjene i en bestilling deler egenskapen _bestilling: hovedlinjen (variant av antall kniver × forsendelse) og tilleggene fra
   produktet tilleggstjenester-sliping. Scriptet
   - lar kunden endre antall kniver og forsendelse (bytter hovedlinjens variant) og antall våtsteinslip. Andre tilleggslinjer vises uten knapper,
   - holder egenskapen «Fordeling» i takt med antall våtsteinslip og kniver,
   - fjerner hele bestillingen med «Fjern», og fjerner tillegg uten hovedlinje (eller uten _bestilling) automatisk,
   - tegner skuffen på nytt som Prestige: cart:prepare-bundled-sections, cart/update.js med sections, så cart:change. På /cart lastes siden på nytt.
   Tilleggsprodukt og SKU for våtsteinslip kommer som data-attributter på dette script-elementet (ts-cart-includes). */
(function () {
  'use strict';
  window.__tsSlipGruppe = { loaded: true, version: '2026-10-12a' };

  var me = document.currentScript || document.querySelector('script[src*="ts-sliping-gruppe"]');
  function cfg(name, fallback) {
    var v = me && me.getAttribute ? me.getAttribute('data-' + name) : null;
    return v === null || v === '' ? fallback : v;
  }
  /* Kundetekster fra locales via snippets/ts-tekst.liquid (window.tsTekst), så /en/ kan oversettes. */
  var T = (window.tsTekst || {}).sliping_gruppe || {};
  function fyll(s, vars) { return String(s).replace(/{{\s*(\w+)\s*}}/g, function (_, k) { return vars[k]; }); }
  var TILLEGG = cfg('tillegg', 'tilleggstjenester-sliping');
  var SKU_VAT = cfg('sku-vat', 'SLIP-VAT');

  var busy = false;
  var mutated = false;          /* satt når en endring (POST) har gått gjennom i handlingen som kjører */
  var sweepTries = 0;
  var pendingError = null;
  var html = document.documentElement;

  /* --- Hjelpere ---------------------------------------------------------------- */
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function rootPath() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function onCartPage() {
    var t = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;
    return t ? t === 'cart' : /\/cart\/?$/.test(location.pathname);
  }
  function fire(name, detail) { html.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); }
  function esc(s) { return String(s).replace(/["\\]/g, '\\$&'); }

  /* fetch først; XMLHttpRequest som reserve hvis et app-script har ødelagt fetch (som i ts-cart-addons.js). */
  function xhr(method, url, body) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open(method, url, true);
      x.setRequestHeader('Accept', 'application/json');
      if (body) x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () {
        var j = {};
        try { j = JSON.parse(x.responseText); } catch (e) {}
        if (x.status >= 200 && x.status < 300) resolve(j);
        else { var err = new Error((j && (j.description || j.message)) || ('HTTP ' + x.status)); err.status = x.status; reject(err); }
      };
      x.onerror = function () { reject(new Error('xhr error')); };
      x.send(body || null);
    });
  }
  function api(method, path, body) {
    var url = rootPath() + path;
    var json = body ? JSON.stringify(body) : null;
    var opts = { method: method, credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } };
    if (json) { opts.headers['Content-Type'] = 'application/json'; opts.body = json; }
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var err = new Error((j && (j.description || j.message)) || ('HTTP ' + r.status));
          err.status = r.status;
          throw err;
        }
        return j;
      });
    }, function (e) {
      /* 13/10 2026: bare GET prøves på nytt. En POST kan ha nådd Shopify selv om svaret ble borte, og da ville add.js lagt inn linjen to ganger. */
      if (method === 'GET') return xhr(method, url, json);
      throw e;
    }).then(function (j) {
      if (method !== 'GET') mutated = true;
      return j;
    });
  }
  function getCart() { return api('GET', 'cart.js'); }

  /* --- Bestillingen i kurvdata ------------------------------------------------- */
  function isTillegg(i) { return i.handle === TILLEGG; }
  function bestilling(i) { return (i.properties && i.properties._bestilling) || ''; }
  function groupOf(cart, b) {
    var main = null, adds = [];
    (cart.items || []).forEach(function (i) {
      if (bestilling(i) === b) {
        if (isTillegg(i)) adds.push(i);
        else if (!main) main = i;
      }
    });
    return { main: main, adds: adds };
  }
  function readData(g) {
    var el = g.querySelector('[data-ts-grp-data]');
    try { return JSON.parse(el.textContent).varianter || []; } catch (e) { return []; }
  }
  function o2(v) { return v == null ? '' : String(v); }
  /* 1/11 2026 (f17): antall kniver = tallet i valg 1, som i ts-sliping-post.js og ts-cart-addons.js (ikke plassen i lista). */
  function antallAv(vars, variantId) {
    var hit = vars.filter(function (v) { return v.id === variantId; })[0];
    return hit ? (parseInt(hit.o1, 10) || 0) : 0;
  }
  /* Fordeling er en egenskap verkstedet leser på ordren, ikke visningstekst: alltid norsk, uansett butikkspråk.
     1/11 2026 (f17): MÅ være tegn for tegn lik fordeling() i ts-sliping-post.js, ellers skriver kurven egenskapen om (ensureFordeling sammenligner tekst). */
  function fordeling(hand, antall) {
    var parts = [];
    if (hand > 0) parts.push(hand + ' våtsteinslip');
    if (antall - hand > 0) parts.push((antall - hand) + ' standard slip');
    return parts.join(', ');
  }
  function vatQty(adds, antall) {
    var n = 0;
    adds.forEach(function (i) { if (i.sku === SKU_VAT) n += i.quantity; });
    return Math.min(n, antall);
  }
  function fail(msg, dirty) { var e = new Error(msg); e.dirty = !!dirty; return e; }

  /* --- Visning: laster, feil, tilstand ------------------------------------------ */
  function groupsOf(b) { return qsa('[data-ts-grp][data-bestilling="' + esc(b) + '"]'); }
  function setBusy(b, on) {
    busy = on;
    groupsOf(b).forEach(function (g) {
      if (on) g.setAttribute('aria-busy', 'true'); else g.removeAttribute('aria-busy');
      var s = g.querySelector('[data-ts-grp-status]');
      if (s) s.hidden = !on;
    });
    fire(on ? 'theme:loading:start' : 'theme:loading:end');
  }
  function showError(b, msg) {
    groupsOf(b).forEach(function (g) {
      var f = g.querySelector('[data-ts-grp-feil]');
      if (!f) return;
      f.textContent = msg || '';
      f.hidden = !msg;
    });
  }
  function applyPending() {
    if (!pendingError) return;
    var p = pendingError;
    if (!groupsOf(p.b).length) return;
    pendingError = null;
    showError(p.b, p.msg);
  }
  try {
    var saved = sessionStorage.getItem('ts-grp-feil');
    if (saved) { sessionStorage.removeItem('ts-grp-feil'); pendingError = JSON.parse(saved); }
  } catch (e) {}

  /* Kontroller: grenser for tellerne, utsolgte valg. Kjøres når markup tegnes (skuff på nytt, sidelast). */
  function enhance(g) {
    g.classList.add('is-js');
    qsa('[data-ts-grp-rediger], [data-ts-grp-trinn]', g).forEach(function (el) { el.hidden = false; });
    qsa('[data-ts-grp-rad][hidden]', g).forEach(function (el) { el.hidden = false; });
    var antall = parseInt(g.getAttribute('data-antall'), 10) || 0;
    qsa('[data-ts-grp-rad]', g).forEach(function (rad) {
      var q = parseInt(rad.getAttribute('data-qty'), 10) || 0;
      var mx = antall;
      var m = rad.querySelector('[data-ts-grp-minus]'), p = rad.querySelector('[data-ts-grp-pluss]');
      if (m) m.disabled = q <= 0;
      if (p) p.disabled = q >= mx;
    });
    var vars = readData(g);
    var selA = g.querySelector('[data-ts-grp-antall]'), selF = g.querySelector('[data-ts-grp-forsendelse]');
    var curF = selF ? selF.value : o2(g.getAttribute('data-forsendelse'));
    var curA = selA ? selA.value : '';
    if (selA) qsa('option', selA).forEach(function (op) {
      op.disabled = !vars.some(function (v) { return String(v.o1) === op.value && o2(v.o2) === curF && v.ok; });
    });
    if (selF) qsa('option', selF).forEach(function (op) {
      op.disabled = !vars.some(function (v) { return String(v.o1) === curA && o2(v.o2) === op.value && v.ok; });
    });
  }
  function enhanceAll() {
    qsa('[data-ts-grp]:not(.is-js)').forEach(enhance);
    applyPending();
  }

  /* --- Tegn på nytt (Prestige-mønsteret) --------------------------------------- */
  function finish() {
    if (onCartPage()) { location.reload(); return new Promise(function () {}); }
    var list = [];
    fire('cart:prepare-bundled-sections', { sections: list });
    return api('POST', 'cart/update.js', { updates: {}, sections: list.join(',') }).then(function (cart) {
      if (cart.sections && Object.keys(cart.sections).length) fire('cart:change', { baseEvent: 'line-item:change', cart: cart });
      else fire('cart:refresh');
      return cart;
    });
  }

  /* --- Kjøring med laste- og feilvisning ---------------------------------------- */
  function run(g, work) {
    if (busy) return;
    var b = g.getAttribute('data-bestilling');
    mutated = false;
    setBusy(b, true);
    showError(b, '');
    work(b).then(finish).then(function () {
      setBusy(b, false);
    }, function (e) {
      var msg = T.feil_oppdatere;
      if (e && e.dirty !== undefined) msg = e.message;      /* egne meldinger (fail) er skrevet for kunden; nettverks- og API-feil får standardteksten */
      if (mutated || (e && e.dirty === true)) {
        /* Noe er endret: tegn kurven på nytt og vis feilen i den nye blokken. Feiler det første kallet, står kurven som før og feilen vises rett i blokken. */
        pendingError = { b: b, msg: msg };
        try { if (onCartPage()) sessionStorage.setItem('ts-grp-feil', JSON.stringify(pendingError)); } catch (x) {}
        setBusy(b, false);
        finish().catch(function () {});
        setTimeout(applyPending, 1500);
        return;
      }
      setBusy(b, false);
      showError(b, msg);
      if (window.console) console.warn('ts-sliping-gruppe:', e && e.message);
    });
  }

  /* Hold «Fordeling» i takt med antall våtsteinslip og kniver. Returnerer kurven. */
  function ensureFordeling(cart, b, vars) {
    var grp = groupOf(cart, b);
    if (!grp.main) return Promise.resolve(cart);
    var antall = antallAv(vars, grp.main.variant_id);
    if (!antall) return Promise.resolve(cart);
    var want = fordeling(vatQty(grp.adds, antall), antall);
    if ((grp.main.properties || {}).Fordeling === want) return Promise.resolve(cart);
    var props = Object.assign({}, grp.main.properties, { Fordeling: want });
    return api('POST', 'cart/change.js', { id: grp.main.key, quantity: grp.main.quantity, properties: props });
  }

  /* --- Handlinger -------------------------------------------------------------- */
  /* Endre antall våtsteinslip (delta ±1), eller legg til raden hvis den ikke finnes (variantId, sku). */
  function opTjeneste(g, variantId, sku, delta) {
    run(g, function (b) {
      var vars = readData(g);
      return getCart().then(function (cart) {
        var grp = groupOf(cart, b);
        if (!grp.main) throw fail(T.finnes_ikke, true);
        var antall = antallAv(vars, grp.main.variant_id);
        var line = grp.adds.filter(function (i) { return i.variant_id === variantId; })[0];
        var now = line ? line.quantity : 0;
        var to = Math.max(0, Math.min(now + delta, antall));
        if (to === now) return cart;
        var p;
        if (line) {
          var up = {}; up[line.key] = to;
          p = api('POST', 'cart/update.js', { updates: up });
        } else {
          p = api('POST', 'cart/add.js', { items: [{ id: variantId, quantity: to, properties: { _bestilling: b } }] }).then(getCart);
        }
        return p.then(function (c) { return ensureFordeling(c, b, vars); });
      });
    });
  }

  /* Bytt hovedlinjens variant (antall kniver og/eller forsendelse): ny linje med samme egenskaper inn først, så ut med den gamle.
     13/10 2026: linjene etter bestillingen flyttes ikke (fjern + legg inn igjen); feilet innleggingen, var varene borte fra kurven.
     Bestillingen kan bytte plass i kurven, men ingenting forsvinner. */
  function opByttVariant(g, n, fors) {
    run(g, function (b) {
      var vars = readData(g);
      return getCart().then(function (cart) {
        var grp = groupOf(cart, b);
        if (!grp.main) throw fail(T.finnes_ikke, true);
        var cur = vars.filter(function (v) { return v.id === grp.main.variant_id; })[0];
        var wantF = fors === null ? (cur ? o2(cur.o2) : '') : fors;
        var target = vars.filter(function (v) { return String(v.o1) === String(n) && o2(v.o2) === wantF; })[0];
        if (!target) throw fail(T.kombinasjon_finnes_ikke);
        if (!target.ok) throw fail(T.kombinasjon_utsolgt);
        if (target.id === grp.main.variant_id) return cart;

        var antall = antallAv(vars, target.id);
        var up = {};
        grp.adds.forEach(function (i) {
          if (i.sku === SKU_VAT && i.quantity > antall) up[i.key] = antall;
        });
        var vat = 0;
        grp.adds.forEach(function (i) { if (i.sku === SKU_VAT) vat += up[i.key] !== undefined ? up[i.key] : i.quantity; });
        var props = Object.assign({}, grp.main.properties, { Fordeling: fordeling(Math.min(vat, antall), antall) });

        return api('POST', 'cart/add.js', { items: [{ id: target.id, quantity: 1, properties: props }] }).then(function () {
          up[grp.main.key] = 0;
          return api('POST', 'cart/update.js', { updates: up }).catch(function (e) {
            /* Den gamle hovedlinjen ble stående: ta bort den nye, så bestillingen ikke står dobbelt. */
            return getCart().then(function (c) {
              var dup = {}, mains = (c.items || []).filter(function (i) { return bestilling(i) === b && !isTillegg(i); });
              if (mains.length > 1) mains.forEach(function (i) { if (i.variant_id === target.id) dup[i.key] = 0; });
              return Object.keys(dup).length ? api('POST', 'cart/update.js', { updates: dup }) : c;
            }).catch(function () {}).then(function () { throw fail(T.kunne_ikke_bytte, true); });
          });
        });
      });
    });
  }

  function opFjern(g) {
    run(g, function (b) {
      return getCart().then(function (cart) {
        var up = {}, n = 0;
        (cart.items || []).forEach(function (i) { if (bestilling(i) === b) { up[i.key] = 0; n++; } });
        return n ? api('POST', 'cart/update.js', { updates: up }) : cart;
      });
    });
  }

  /* --- Tillegg uten hovedlinje fjernes ----------------------------------------- */
  function orphanUpdates(items) {
    var mains = {}, up = {}, n = 0;
    (items || []).forEach(function (i) { if (!isTillegg(i) && bestilling(i)) mains[bestilling(i)] = true; });
    (items || []).forEach(function (i) {
      if (isTillegg(i) && !(bestilling(i) && mains[bestilling(i)])) { up[i.key] = 0; n++; }
    });
    return n ? up : null;
  }
  function sweep(cart) {
    if (busy || sweepTries >= 3 || !cart || !cart.items || !orphanUpdates(cart.items)) return;
    sweepTries++;
    busy = true;
    fire('theme:loading:start');
    /* Hent kurven på nytt før noe fjernes, så en utdatert kopi ikke fjerner riktige linjer. */
    getCart().then(function (fresh) {
      var up = orphanUpdates(fresh.items);
      if (!up) return null;
      return api('POST', 'cart/update.js', { updates: up }).then(function () { return true; });
    }).then(function (did) {
      busy = false;
      fire('theme:loading:end');
      if (did) finish().catch(function () {});
    }, function (e) {
      busy = false;
      fire('theme:loading:end');
      if (window.console) console.warn('ts-sliping-gruppe: opprydding feilet', e && e.message);
    });
  }
  function sweepFromDom() {
    if (document.querySelector('[data-ts-orphan]')) getCart().then(sweep).catch(function () {});
  }

  /* --- Hendelser --------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var g = t && t.closest ? t.closest('[data-ts-grp]') : null;
    if (!g || !g.classList.contains('is-js')) return;
    var fjern = t.closest('[data-ts-grp-fjern]');
    if (fjern) {
      e.preventDefault();
      e.stopImmediatePropagation();
      opFjern(g);
      return;
    }
    var rad = t.closest('[data-ts-grp-rad]');
    var minus = t.closest('[data-ts-grp-minus]'), pluss = t.closest('[data-ts-grp-pluss]');
    if (rad && (minus || pluss)) {
      e.preventDefault();
      opTjeneste(g, parseInt(rad.getAttribute('data-variant'), 10), rad.getAttribute('data-sku'), pluss ? 1 : -1);
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    var g = t && t.closest ? t.closest('[data-ts-grp]') : null;
    if (!g || !g.classList.contains('is-js')) return;
    var selA = g.querySelector('[data-ts-grp-antall]'), selF = g.querySelector('[data-ts-grp-forsendelse]');
    if (t === selA || t === selF) {
      e.stopPropagation();
      opByttVariant(g, selA ? selA.value : '', selF ? selF.value : null);
      return;
    }
  }, true);

  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && cart.items) setTimeout(function () { sweep(cart); }, 0);
    setTimeout(enhanceAll, 60);
  });
  document.addEventListener('cart-drawer:refreshed', function () {
    setTimeout(function () { enhanceAll(); sweepFromDom(); }, 30);
  });

  /* Skuffen og /cart tegnes på nytt uten sidelast: se etter nye blokker.
     1/11 2026 (f20): bare i skuff- og kurvseksjonen, ikke hele body på hver side. cart:refresh tegner uten egen hendelse til oss, derfor observatøren. */
  function start() {
    enhanceAll();
    sweepFromDom();
    if (window.MutationObserver) {
      var t = null;
      var mo = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(enhanceAll, 20);
      });
      qsa('.shopify-section--cart-drawer, .shopify-section--main-cart').forEach(function (s) {
        mo.observe(s, { childList: true, subtree: true });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
